/* eslint-disable no-unused-vars */
import React, { FunctionComponent } from 'react';
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

interface Props {
  label: string;
  disabled?: boolean;
  multiLine?: boolean;
  width?: string;
  size?: any;
  value?: string;
  type?: string;
  error?: boolean;
  helperText?: string;
  onChange?: (e: any) => void;
}

const CssTextField = styled(TextField)({
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: '#000000',
  },
  '& .MuiFormLabel-root.Mui-disabled': {
    color: 'grey',
  },
});

export const MyTextFiled: FunctionComponent<Props> = ({
  label,
  multiLine,
  disabled,
  width,
  size,
  value,
  type,
  error,
  helperText,
  onChange,
}) => (
  <CssTextField
    label={label}
    value={value}
    variant="filled"
    type={type}
    onChange={onChange}
    error={error && value === ''}
    multiline={multiLine}
    disabled={disabled}
    style={{
      width,
      fontFamily: 'SF Compact Display',
    }}
    helperText={error && value === '' ? 'Введите значение' : helperText}
    size={size}
  />
);

MyTextFiled.defaultProps = {
  value: '',
  disabled: false,
  multiLine: false,
  width: '100%',
  size: 'large',
  type: 'text',
  error: false,
  helperText: '',
  onChange: undefined,
};
